const ORGANIZATION_NAME_COOKIE_KEY = "organizationName";
const PROGRAM_NAME_COOKIE_KEY = "programName";

const getCookieAttributes = () => {
  const attributes = ["path=/", "SameSite=Lax"];

  if (window.location.protocol === "https:") {
    attributes.push("Secure");
  }

  return attributes.join("; ");
};

const getCookieValue = (name: string) => {
  const cookie = document.cookie
    .split("; ")
    .find((entry) => entry.startsWith(`${name}=`));

  if (!cookie) return "";

  return decodeURIComponent(cookie.slice(name.length + 1));
};

const setCookieValue = (name: string, value: string) => {
  document.cookie = `${name}=${encodeURIComponent(value)}; ${getCookieAttributes()}`;
};

const removeCookieValue = (name: string) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; ${getCookieAttributes()}`;
};

export const getCoachMetadata = () => ({
  organizationName: getCookieValue(ORGANIZATION_NAME_COOKIE_KEY),
  programName: getCookieValue(PROGRAM_NAME_COOKIE_KEY),
});

export const setCoachMetadata = (organizationName: string, programName: string) => {
  if (organizationName) {
    setCookieValue(ORGANIZATION_NAME_COOKIE_KEY, organizationName);
  } else {
    removeCookieValue(ORGANIZATION_NAME_COOKIE_KEY);
  }

  if (programName) {
    setCookieValue(PROGRAM_NAME_COOKIE_KEY, programName);
  } else {
    removeCookieValue(PROGRAM_NAME_COOKIE_KEY);
  }
};

export const clearCoachMetadata = () => {
  removeCookieValue(ORGANIZATION_NAME_COOKIE_KEY);
  removeCookieValue(PROGRAM_NAME_COOKIE_KEY);
};
